import React from 'react'

export default function AdditionalInformationSection({
  formData,
  handleInputChange,
  isFieldDisabled,
}) {
  return (
    <div className="form-section">
      <h3>Additional Information</h3>
      <div className="form-group">
        <label htmlFor="rules">League Rules</label>
        <textarea
          id="rules"
          name="rules"
          value={formData.rules}
          onChange={handleInputChange}
          rows="4"
          disabled={isFieldDisabled('rules')}
          title={
            isFieldDisabled('rules')
              ? `Cannot change rules in ${formData.league_status} status`
              : ''
          }
        />
      </div>

      <div className="form-group">
        <label htmlFor="banner_url">Banner Image URL</label>
        <input
          id="banner_url"
          name="banner_url"
          type="url"
          value={formData.banner_url}
          onChange={handleInputChange}
          placeholder="https://..."
          disabled={isFieldDisabled('banner_url')}
          title={
            isFieldDisabled('banner_url')
              ? `Cannot change banner in ${formData.league_status} status`
              : ''
          }
        />
      </div>

      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            name="public_visible"
            checked={formData.public_visible}
            onChange={handleInputChange}
            disabled={isFieldDisabled('public_visible')}
            title={
              isFieldDisabled('public_visible')
                ? `Cannot change visibility in ${formData.league_status} status`
                : ''
            }
          />
          Make this league visible to the public
        </label>
      </div>
    </div>
  )
}
